<script>
    import PartComboSelect from '../../ComboSelect/PartComboSelect.svelte';
    import { sgettext } from '../../../i18n.js';

    export let data = '';
    export let label = '';
    export let options = [];
    export let onChange = () => {};
    export let row = null;
    export let key = '';
    export let schema = {}
    export let id = '';
    

    let selected = null;

    function handleColumnChange(event) {
        onChange(event, {...row, part: selected});
    }

</script>

<style>
    .sap-number {
        margin-top: 6px;
        font-size: 14px;
    }


</style>

<PartComboSelect
    {id}
    {label}
    {key}
    bind:options={options}
    bind:value={data}
    bind:selected={selected}
    on:changed={handleColumnChange} 
    searchable={true}
    bind:isValid={row.fieldValidations[key].isValid}
    bind:errors={row.fieldValidations[key].errors}
    {schema} />

{#if selected && selected.sap_part_number}
<div class="sap-number">
    <label>{sgettext('$$SAP_PART_NUMBER$$')}: </label>
    <span>{selected.sap_part_number}</span>
</div>
{/if}